(function ($){
    // global variables
    const BODY = $('body');

    let mainNav = $('.main-nav .splide');
    mainNav.each(function (i, e){

        let that = $(this);
        let view_mode = that.attr('data-view-mode');
        let options = {};

        if(view_mode === '2'){
            options = {
                rewind: true,
                grid: {
                    rows: 2,
                    cols: 3,
                    gap: {
                        row: 20,
                        col: 0,
                    },
                },
                breakpoints: {
                    992: {
                        grid: {
                            rows: 1,
                            cols: 2,
                            gap: {
                                row: 20,
                                col: 0,
                            },
                        }
                    },
                    576: {
                        grid: {
                            rows: 1,
                            cols: 1,
                            gap: {
                                row: 0,
                                col: 0,
                            },
                        }
                    },
                }
            }
        } else {
            options = {
                perPage: 3,
                rewind : true,
                gap: 0,
                breakpoints: {
                    992: {
                        perPage: 2
                    },
                    480: {
                        perPage: 1,
                    },
                }
            }
        }

        let splide = new Splide(e, options);

        splide.mount(window.splide.Extensions);
    });

    $('.promo .splide').each(function (i, e){
        let splide = new Splide(e, {
            type : 'fade',
            rewind: true,
            arrows: false,
            autoplay: true,
            rewind: true,
            interval: 4000,
            pauseOnHover: false,
            pauseOnFocus: false,
    
        });

        splide.mount();

    });

    $('.product-bundle__slider .splide').each(function (i, e){
        let splide = new Splide(e, {
            type : 'fade',
            rewind: true,
            arrows: true,
            autoplay: false,
            interval: 5000,
        });

        splide.mount();
    });

    $('.advantages__list .splide').each(function (i, e){
        let splide = new Splide(e, {
            type : 'slide',
            rewind: true,
            arrows: false,
            autoplay: true,
            interval: 5000,
            mediaQuery: 'min',
            autoHeight: false,
            breakpoints: {
                992: {
                    destroy: true
                },
                576: {
                    perPage: 2,
                    gap: 30,
                }
            }
        });

        splide.mount();
    });

    $('#comments .splide').each(function (i, e){
        let splide = new Splide(e, {
            type : 'slide',
            rewind: true,
            arrows: false,
            autoplay: true,
            interval: 5000,
            mediaQuery: 'min',
            autoHeight: false,
            breakpoints: {
                992: {
                    destroy: true
                },
                768: {
                    perPage: 1,
                    gap: 30,
                }
            }
        });

        splide.mount();
    });

    $('.product-categories .splide').each(function (i, e){
        let splide = new Splide(e, {
            perPage: 4,
            rewind : true,
            gap: 0,
            arrows: false,
            breakpoints: {
                1200: {
                    perPage: 3
                },
                992 : {
                    perPage: 2
                },
                576: {
                    perPage: 1,
                },
            }
        });

        splide.mount();
    });

    $('.articles-slider .splide').each(function (i, e){
        let splide = new Splide(e, {
            perPage: 4,
            rewind : true,
            gap: 0,
            arrows: false,
            breakpoints: {
                1400: {
                    perPage: 3
                },
                992 : {
                    perPage: 2
                },
                576: {
                    perPage: 1,
                },
            }
        });

        splide.mount();
    });

    $('.our-instagram .splide').each(function (i, e){
        let splide = new Splide(e, {
            perPage: 5,
            rewind : true,
            gap: 16,
            arrows: true,
            pagination: false,
            breakpoints: {
                1400: {
                    perPage: 4
                },
                1200: {
                    perPage: 3
                },
                992 : {
                    perPage: 2
                },
                768 : {
                    arrows: false,
                    pagination: true,
                },
                576: {
                    perPage: 1,
                },
            }
        });

        splide.mount();
    });

    $('.products-slider .splide').each(function (i, e){
        let splide = new Splide(e, {
            perPage: 4,
            rewind : true,
            gap: 0,
            arrows: true,
            breakpoints: {
                1200: {
                    perPage: 3
                },
                992 : {
                    perPage: 2,
                    arrows: false,
                },
                576: {
                    perPage: 1,
                },
            }
        });

        splide.mount();
    });

    $('#menu-primary-menu > li.menu-item-has-children > a').after('<span class="main-nav__dropdown-item-icon"><i class="icon-chevron-right"></i></span>');

    // menu
    $('.menu-icon').on('click', function () {
        let m = $(this);

        if(m.is('.active')){
            m.removeClass('active');
            $('#main-nav-wrapper, body').removeClass('active');
            $('body').removeClass('body-overflow');
        } else {
            m.addClass('active');
            $('#main-nav-wrapper, body').addClass('active');
            $('body').addClass('body-overflow');
        }

        checkMobilePosition();
    });

    $('.main-nav__dropdown-item-icon').on('click', function (){
        let that = $(this);
        let dropdown = that.siblings('.main-nav__dropdown');

        that.toggleClass('active');
        dropdown.toggleClass('active');
        that.siblings('.sub-menu').toggleClass('active');
    });


    // sort select
    $('#sort').on('change', function (){
        document.location.search = this.options[this.selectedIndex].value;
    });


    // play video btn
    $('.play-button').magnificPopup({type:'iframe'});

    // run scripts on resize
    $(window).on('resize', function (){
        get_offset_top();
    });

    // run scripts on scroll
    $(window).on('scroll', function (){
        checkMobilePosition();
    });

    $(window).on('resize', function (){
        checkMobilePosition();
    });

    get_offset_top();


    function anchor(e) {
        e.preventDefault();
        let ank = $(this).attr('href');
        let section = BODY.find(ank);
        let adminBarHeight = $('#wpadminbar').outerHeight();

        if (section.length > 0) {
            let topToScroll = section.offset().top - $('#header').outerHeight() - (adminBarHeight !== undefined ? adminBarHeight : 0);

            $('html, body').animate({
                scrollTop: topToScroll
            }, 300);
        }
    }
    BODY.on('click', '.js-anchor', anchor);

    // duplication
    $('.js-duplication').on('change', function (){
        let that = $(this),
            origin_id = that.attr('data-id-origin'),
            origin = $('#' + origin_id);

        origin.val(that.val()).trigger('change');
    });

    // if user on account page and not logged
    if(BODY.is('.woocommerce-account') && !BODY.is('.logged-in ')){
        let modal_login = new bootstrap.Modal('#modal-login'),
            modal_reset_password = bootstrap.Modal.getInstance('#modal-reset-password'),
            urlParams = new URLSearchParams(window.location.search);

        if(BODY.is('.woocommerce-lost-password') && urlParams.get('show-reset-form') !== 'true'){
            modal_reset_password.show();
        } else if(urlParams.get('show-reset-form') !== 'true') {
            modal_login.show();
        }
    }

    $('#filter-mobile').on('click', function (){
        let that = $(this),
            filter = $('.filter');

        if(that.is('.active')){
            that.removeClass('active');
            filter.slideUp(200);
        } else {
            that.addClass('active');
            filter.slideDown(200);
        }
    });

    $('.editor-section >' +
        ' table').each(function (){
        let table = $(this);

        table.wrap('<div class="table-responsive"></div>');
    });

    $('.js-bg-section').each(function (){
        let that = $(this),
            item = that.find('.js-bg-section__item');

        item.each(function (){
            let item_current = $(this),
                xPercent = parseInt(item_current.attr('data-xPercent'))

            gsap.to(item_current, {
                xPercent: xPercent,
                x: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window),
                ease: "none",
                scrollTrigger: {
                    trigger: that,
                    // start: "top bottom", // the default values
                    // end: "bottom top",
                    scrub: true,
                    duration: {min: 0.2, max: 3}
                },
            });
        });
    });

    // modal promo
    $('.js-modal-promo').each(function (){

        let that = $(this),
            popup = new bootstrap.Modal(that),
            modal_id = parseFloat(that.attr('data-modal-id')),
            delay = parseFloat(that.attr('data-delay')) * 1000,
            promo_modals = Cookies.get('promo_modals');

        // check cookie promo modals
        if(promo_modals === undefined){
            promo_modals = [];
        } else {
            promo_modals = JSON.parse(promo_modals);
        }

        if($.inArray(modal_id, promo_modals) === -1){

            setTimeout(function (){
                promo_modals.push(modal_id);

                Cookies.set('promo_modals',  JSON.stringify(promo_modals), {});

                popup.show();
            }, delay);
        }
    });

    // password validation
    BODY.on('change', '.js-password-validation', function(){
        let input = $(this);

        input_password_validation(input);
    });
}(jQuery));

function showError(errorInput, message) {
    $('.error-message').remove();
    errorInput.focus();
        errorInput.after('<div class="error-message">'+ message +'</div>');
}

function showErrorTerms(errorInput, message) {
    $('.error-message').remove();
    errorInput.focus();
    errorInput.closest('li').append('<div class="error-message">'+ message +'</div>');
}

function checkMobilePosition(){
    let mth = $('#header').offset().top - $(document).scrollTop();
    let t = $('#header').height() + mth;
    let t_px = t + 1 + 'px';

    $('#main-nav-wrapper').css({
        'top' : t_px,
        'height' : 'calc(100% - ' + t_px + ')'
    });
}

function input_password_validation(input){
    let that = $(input),
        regexp = /^[a-z0-9]+$/i,
        val = that.val(),
        status = false;

    if(!(regexp.test(val) && val.length > 7)){
        that.addClass('error');
    } else {
        that.removeClass('error');
        status = true;
    }

    return status;
}